import onFailedUpload from '@shoflo/studio-redux/actions/source/onFailedUpload';
import setSourceUploadStatus from '@shoflo/studio-redux/actions/source/setSourceUploadStatus';
import showUploadStatus from '@shoflo/studio-redux/actions/source/showUploadStatus';
import { UPLOADING } from '@shoflo/polymer/constants/SourceUploadStatus';
import { PDF_FILE } from '@shoflo/polymer/constants/SourceItems';
import {
  readFileAsBinary,
  uploadEventDoc
} from '@shoflo/studio-redux/utils/sources';
import fileTypes from '@shoflo/studio-redux/constants/FileTypes';
import { BANNER } from '@studio/constants/Sources';
import axios from 'axios';

export const DEFAULT_ORDER_NUMBER = 0;

async function handlePDFUpload(
  source,
  dispatch,
  isS3ProxyFlagEnabled,
  apiClient,
  teamId,
  eventId,
  contentUploadSLICallback
) {
  const { name: fileName = '' } = source.value || {};

  const order = DEFAULT_ORDER_NUMBER;

  // Get the data needed for the payload from the source
  const { value, description = '', title } = source;
  const payload = { order, value, description, type: PDF_FILE, title };
  dispatch(setSourceUploadStatus(fileName, UPLOADING));
  dispatch(showUploadStatus());
  let eventDocumentId;

  if (isS3ProxyFlagEnabled) {
    const createDocumentResponse = await apiClient.eventDoc.createDocument(
      teamId,
      eventId,
      {
        name: fileName,
        description: 'Media Content',
        isStudioMedia: true
      }
    );
    const {
      _id: eventDocId,
      preSignedUploadUrl,
      preSignedUploadHeaders
    } = createDocumentResponse;
    const binaryData = await readFileAsBinary(source.value);
    const fileExtension = fileName.split('.').pop().toLowerCase();
    const contentType = fileTypes[fileExtension][0];
    await axios.put(preSignedUploadUrl, binaryData, {
      headers: {
        'Content-Type': contentType,
        'x-amz-tagging': preSignedUploadHeaders['x-amz-tagging']?.join(',')
      }
    });

    eventDocumentId = eventDocId;
  } else {
    const onFailedUploadCallback = onFailedUpload(dispatch, fileName);

    const eventDoc = await uploadEventDoc(
      teamId,
      eventId,
      source.value,
      true,
      undefined,
      Object.create(null),
      onFailedUploadCallback,
      contentUploadSLICallback,
      source
    );
    eventDocumentId = eventDoc._id;
  }

  payload.value = { eventDocId: eventDocumentId };
  return { fileName, payload };
}

function getSourceBannerLayer(program, sourceId) {
  return program.layers.find(
    layer =>
      layer?.source?.type === BANNER && layer?.source?._id.includes(sourceId)
  );
}

function updateBannerVariablesForLayer(bannerLayer, changes) {
  bannerLayer.source.value.templateVars.LINE_1 = changes.title;
  bannerLayer.source.value.templateVars.LINE_2 = changes.description;

  return bannerLayer;
}

export { handlePDFUpload, getSourceBannerLayer, updateBannerVariablesForLayer };
